import { type MouseEvent, type SyntheticEvent } from "react"

import {
  selectAuthFlowEmail,
  selectAuthFlowError,
  selectAuthFlowLoading,
} from "@/lib/storage/auth-slice"
import {
  handleRegisterStepSubmit,
  showSignInStep,
} from "@/lib/storage/auth-thunks"
import { useAppDispatch, useAppSelector } from "@/lib/storage/hooks"
import { AuthProviderButtons } from "@/components/auth/auth-provider-buttons"
import { Button } from "../ui/button"
import { Form } from "../ui/form"
import { OrgNewsletterCheckbox } from "./org-newsletter-checkbox"
import { RegistrationForm } from "./registration-form"
import { RegistrationTermsDisclaimer } from "./registration-terms-disclaimer"

export default function AuthStepRegister() {
  const dispatch = useAppDispatch()
  const email = useAppSelector(selectAuthFlowEmail)
  const loading = useAppSelector(selectAuthFlowLoading)
  const error = useAppSelector(selectAuthFlowError)

  const handleSubmit = async (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault()
    void dispatch(handleRegisterStepSubmit())
  }

  const switchToSignin = (e: MouseEvent, prefillEmail?: boolean) => {
    e.preventDefault()
    const providers: ("email" | "google" | "apple")[] = [
      "email",
      "google",
      "apple",
    ] // All providers available for sign-in
    void dispatch(
      showSignInStep({
        email: prefillEmail ? email : "",
        providers,
      })
    )
  }

  return (
    <>
      {/* hack to replace "log in" in error message with actionable button */}
      {error && (
        <p className="font-medium text-destructive">
          {...error.split(/(log in)/).map((chunk, i) =>
            chunk === "log in" ? (
              <button
                key={i}
                onClick={(e) => switchToSignin(e, true)}
                className="font-semibold hover:underline"
              >
                log in
              </button>
            ) : (
              chunk
            )
          )}
        </p>
      )}
      <Form onSubmit={handleSubmit}>
        <RegistrationForm />
        <Button
          type="submit"
          variant="primary"
          size="lg"
          block
          loading={loading}
        >
          Continue
        </Button>
        {/* -mt-1 matches the email step's spacing */}
        <RegistrationTermsDisclaimer className="-mt-1" />
      </Form>
      <OrgNewsletterCheckbox className="ml-1" />
      <AuthProviderButtons />
    </>
  )
}
